export default "__VITE_ASSET__hwE38O3I__";